module.exports = __webpack_public_path__ + "img/03n.227c18cb.png";